import { gql } from '../../__generated__/gql'

export const COMMUNITY_HIDE_COMMENT_MUTATION = gql(`
    mutation hideCommunityComment( $id: Int! ) {
      hideCommunityComment(input: { id: $id }) {
        clientMutationId
      }
    }
`)
